document.addEventListener("alpine:init", () => {
    Alpine.data("animatedHero", (vidsrc, mobsrc) => ({
        videoType: "upload",
        videoPlaying: true,
        video: null,
        vid: null,
        videoPlayer: null,
        vidSrc: vidsrc,
        mobSrc: mobsrc,
        isMobile: true,
        loaded: false,
        animationDuration: 1250,
        init() {
            this.video =
                this.$root.querySelector("video.media-video") ||
                this.$root.querySelector("iframe.media-video");

            this.videoPlayer = this.$root.querySelector(
                "#Animated__Hero-video source",
            );

            this.vid = this.$root.querySelector("#Animated__Hero-video");

            this.videoPlaying = true;

            let prevWidth = 0;

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 960;

                let width = window.outerWidth;

                if (width !== prevWidth) {
                    prevWidth = width;
                    if (!this.isMobile && this.vidSrc) {
                        this.videoPlayer.src = this.vidSrc;
                        this.vid.load();
                    } else {
                        this.videoPlayer.src = this.mobSrc;
                        this.vid.load();
                    }
                }
            }, true);

            setTimeout(() => {
                this.loaded = true;
            }, this.animationDuration);
        },
    }));
});
